import * as React from 'react';
import { DATA_ATTRIBUTES, DATA_HOOKS } from './constants';
import ChevronDown from 'wix-ui-icons-common/on-stage/ChevronDown';
import classnames from 'classnames';
import { TPAComponentsContext } from '../TPAComponentsConfig';
import { st as buttonSt } from '../Button/Button.st.css';
import { st, classes } from './DropdownNativeSelect.st.css';
class DropdownNativeSelectComponent extends React.Component {
    onSelect(e) {
        const { selectedOption: prevSelectedOption } = this.props;
        const optionId = e.target.value;
        if ((prevSelectedOption && prevSelectedOption.id) === optionId) {
            return;
        }
        const selectedOption = this.props.options.find(({ id }) => id === optionId);
        this.props.onSelect(selectedOption);
    }
    renderOptions(hasPlaceholder) {
        const { placeholder, options } = this.props;
        return (React.createElement(React.Fragment, null,
            hasPlaceholder && (React.createElement("option", { "data-hook": DATA_HOOKS.placeholderOption, value: "", disabled: true }, placeholder)),
            options.map((option, i) => !option.divider ? (React.createElement("option", { key: i, value: option.id, disabled: !option.isSelectable }, option.value)) : null)));
    }
    renderOptionIcon() {
        return (React.createElement("div", { className: classes.optionIcon }, this.props.selectedOption.icon));
    }
    getDataAttributes() {
        const { error } = this.props;
        return {
            [DATA_ATTRIBUTES.error]: error,
        };
    }
    render() {
        const { disabled, selectedOption, error, errorMessage, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, id: dropdownId, className, name, errorComponent, newErrorMessage, } = this.props;
        const { rtl } = this.context;
        const hasPlaceholder = !selectedOption || !selectedOption.value;
        const shouldRenderIcon = selectedOption && !!selectedOption.icon;
        const buttonStyle = buttonSt(classes.root, {
            fullWidth: true,
        });
        const nativeSelectStyles = st(classes.root, {
            error,
            disabled,
            placeholder: hasPlaceholder,
            icon: shouldRenderIcon,
            rtl,
        }, className);
        return (React.createElement("div", { className: classes.wrapper },
            React.createElement("select", Object.assign({}, this.getDataAttributes(), { defaultValue: "" }, (selectedOption && { value: selectedOption.id }), { id: dropdownId, onChange: (e) => this.onSelect(e), "data-hook": DATA_HOOKS.nativeSelect, ref: this.props.innerRef, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, disabled: disabled, name: name, className: classnames(nativeSelectStyles, buttonStyle) }), this.renderOptions(hasPlaceholder)),
            shouldRenderIcon ? this.renderOptionIcon() : null,
            error && errorMessage && !newErrorMessage && errorComponent,
            React.createElement(ChevronDown, { className: classes.arrowIcon })));
    }
}
DropdownNativeSelectComponent.contextType = TPAComponentsContext;
export const DropdownNativeSelect = React.forwardRef((props, ref) => (React.createElement(DropdownNativeSelectComponent, Object.assign({}, props, { innerRef: ref }))));
//# sourceMappingURL=DropdownNativeSelect.js.map